import { useAuth } from "@/lib/auth";

/**
 * Hook that returns { has(action), role, permissions }.
 * Keeps UI decisions in sync with backend RBAC in server.py::ROLE_PERMISSIONS.
 */
export function usePerms() {
  const { user } = useAuth();
  const perms = new Set(user?.permissions || []);
  const role = user?.role || "viewer";
  return {
    role,
    permissions: Array.from(perms),
    has: (action) => perms.has(action),
    canWrite: () => perms.size > 0,
    isViewer: () => role === "viewer",
    isAdmin: () => role === "admin",
    isOperator: () => role === "operator" || role === "user",
  };
}
